import React, { useState, useEffect } from "react";
import { Row, Col,Card } from "react-bootstrap";
import { fetchJson } from "../utils/fetchJson";
const AboutPage = () => {
  const [menu, setMenu] = useState([]);
  const [partnels, setPartnels] = useState([]);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth < 768);
    checkMobile();
    window.addEventListener("resize", checkMobile);
    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  useEffect(() => {
    getMenu();
    getPartner();
  }, []);
  const getMenu = () => {
    fetchJson("/json/aboutMenu.json")
      .then((response) => response.json())
      .then((data) => setMenu(data))
      .catch((error) => console.error("menu:", error));
  };

  const getPartner = () => {
    fetchJson("/json/partner.json")
      .then((response) => response.json())
      .then((data) => setPartnels(data))
      .catch((error) => console.error("partnels:", error));
  };

  return (
    <div>

      <div className="page-title">
        <h1>About FAR</h1>
      </div>

      <Row>
        <Col xs={12} md={3}>
          <Card 
            style={{
              maxHeight: isMobile ? "calc(100vh - 40px)" : "calc(100vh - 100px)",
              overflowY: "auto",
              padding: isMobile ? "1rem" : "1.5rem",
              position: isMobile ? "static" : "sticky", 
              top: isMobile ? "auto" : "100px",
              left: isMobile ? "auto" : 0,
              zIndex: 10, 
            }}
          >
            <Card.Header style={{
              padding: 0,
              borderBottom: "2px solid #3498db",
              marginBottom: "1rem",
              backgroundColor: "transparent",
            }}>
              <h3 style={{
                color: "#2c3e50",
                paddingBottom: "10px",
                margin: 0,
                fontSize: isMobile ? "1.2rem" : "1.3rem",
              }}>
              Overview
              </h3>
            </Card.Header>
            <Card.Body style={{ padding: 0 }}>
          <ul className="p-0">
            {menu.map(({ id, title, link }) => (
              <li key={id} >
                <a
                  href={link}
                  className={`btn d-flex justify-content-between align-items-center btn-secondary`}
                  style={{
                    display: "block",
                    textAlign: "left",
                    padding: "8px 15px",
                    borderRadius: "8px",
                    transition: "all 0.3s ease",
                    width: "100%",
                  }}
                >
                  <span
                    style={{
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                      flexGrow: 1,
                      marginRight: "8px",
                    }}
                  >
                    {title}
                  </span>
                </a>
              </li>
            ))}
          </ul>
            </Card.Body>
          </Card>
        </Col>
        <Col xs={12} md={9}>
          <main style={{flex:1}}>
            <div className="card">
              <div className="page_content">
                <div className="mb-30">
                  <h2>About FAR</h2>
                  <p style={{ textAlign: "justify"}}>
                    FAR Publishing was founded in November 2022 and is a fully
                    open access publishing house registered in Hong Kong with
                    an international perspective and internet thinking. FAR is
                    the abbreviation for Forth Academic Research, meaning
                    cutting-edge academic research, publishing numerous
                    journals in the fields of science and medicine. FAR is
                    committed to collaborating with global researchers and
                    publishing peer-reviewed high-quality journals to serve
                    the global research community. Collaborate with global
                    publishing houses, research institutions, and societies to
                    jointly build an ecosystem for scientific publishing and
                    improve open access publishing mechanisms.
                  </p>
                </div>
              </div>
            </div>
            <div className="card">
              <div className="page__content">
                <div className="mb-30">
                  <h2>Corporate Partners</h2>
                  <Row>
                    {partnels.map((_, index) => (
                      <Col
                        xs={12} md={6} lg={4}
                        className="d-flex justify-center p-3"
                        key={index}
                      >
                        <div
                          className="d-flex"
                          style={{ flexDirection: "column" }}
                        >
                          {_.link ? (
                            <a
                              href={_.link}
                              target="_blank"
                              rel="noopener noreferrer"
                            >
                              <img
                                style={{
                                  objectFit: "cover",
                                  height: "50px",
                                  cursor: "pointer",
                                }}
                                src={_.url}
                                alt="img"
                              />
                            </a>
                          ) : (
                            <img
                              style={{
                                objectFit: "cover",
                                height: "50px",
                              }}
                              src={_.url}
                              alt="img"
                            />
                          )}
                        </div>
                      </Col>
                    ))}
                  </Row>
                </div>
              </div>
            </div>
          </main>
        </Col>
      </Row>

    </div>
  );
};

export default AboutPage;
